import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import DealerOpeningTimes, { OpeningHoursPropType } from './DealerOpeningTimes.layout';
import OpeningTimesValidator from './OpeningTimesValidator';

export default class DealerOpeningTimesState extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      openingTimes: props.openingTimes,
    };
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (nextProps.openingTimes !== state.openingTimes) {
      return {
        openingTimes: nextProps.openingTimes,
        isEditing: false,
      };
    }
    return null;
  }

  handleEditClick = () => this.setState({ isEditing: true });

  handleCancelClick = () => this.setState({ isEditing: false });

  handleSubmit = (values, actions) => {
    const { doUpdateOpeningTimes, onUpdateError } = this.props;
    const payload = Object.entries(values).reduce(removeClosedDays, {});

    doUpdateOpeningTimes(payload)
      .catch(onUpdateError)
      .finally(() => {
        this.setState({ isEditing: false });
        actions.setSubmitting(false);
        actions.resetForm();
      });
  };

  render() {
    const { openingTimes } = this.state;
    return (
      <Formik
        enableReinitialize
        initialValues={openingTimes}
        onSubmit={this.handleSubmit}
        validate={values => OpeningTimesValidator.validate(values)}
        render={({ values, errors, resetForm, handleSubmit, isSubmitting }) => (
          <Form>
            <DealerOpeningTimes
              openingTimes={values}
              errors={errors}
              onSaveClick={handleSubmit}
              onEditClick={this.handleEditClick}
              onCancelClick={this.handleCancelClick}
              onResetForm={resetForm}
              isEditing={this.state.isEditing}
              isSaving={isSubmitting}
            />
          </Form>
        )}
      />
    );
  }
}

DealerOpeningTimesState.propTypes = {
  doUpdateOpeningTimes: PropTypes.func.isRequired,
  openingTimes: OpeningHoursPropType.isRequired,
  onUpdateError: PropTypes.func,
};

DealerOpeningTimesState.defaultProps = {
  onUpdateError: Function.prototype,
};

const removeClosedDays = (openingTimes, [day, dayValues]) =>
  dayValues.isOpen ? { ...openingTimes, [day]: dayValues } : openingTimes;



// WEBPACK FOOTER //
// ../ui-components/components/DealerOpeningTimes/DealerOpeningTimes.state.jsx